import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  data() {
    return {
      loading: false,
      razones_soc: [],
      empresa: 0,
      formapago: "2",

      tipo: {
        urls: ['https://fidelius.com.ar/assets/img/tarjetas/defa.png', "https://fidelius.com.ar/assets/img/tarjetas/visa.png", "https://fidelius.com.ar/assets/img/tarjetas/master.png", 'https://fidelius.com.ar/assets/img/tarjetas/banco.png'],

      },

      anno_base: 2021,

      pago: {
        tipo: "",
        numero: "",
        cargada: ""
      },

      card: {
        tipo: "0",
        numero: "",
        dni: "",
        mes: "",
        anno: "",
        cvc: "",
        nombre: "",
        email: "",
      },

      banco: {
        nombre: "",
        dni: "",
        tipo_cuenta: "CC",
        nro_cuenta: "",
        sucursal: "",
        cuit: "",
        banco: "",
        CBU: ""
      },
      cvs_tipo: "password"

    };
  },

  computed: {},
  mounted: function () {
    window.comp1 = this;
    $(".box").boxWidget();
    this.get_razones_sociales();
 
  },

  methods: {
 

    upload_cbu() {


      if (this.banco.CBU.length == 22) {
        if (this.banco.dni.length > 6 && this.banco.dni.length < 9) {

          if (this.banco.nombre != "" &&
            this.banco.dni != "" &&
            this.banco.tipo_cuenta != "0" &&
            this.banco.nro_cuenta != "" &&
            this.banco.sucursal != "" &&
            this.banco.banco != "" &&
            this.banco.CBU != "") {
            this.loading = true;
            this.$http
              .post(
                "SERVER/scd/configs/",
                {
                  a: "upcbu",
                  data: this.banco,
                  rz: this.empresa
                },
                {
                  withCredentials: true
                }
              )
              .then(response => {
                if (response.data.status == 1) {
                  this.showNotification({
                    msj: "CBU asociado",
                    bg: "bg-green"
                  });

                  this.banco = {
                    nombre: "",
                    dni: "",
                    tipo_cuenta: "CA",
                    nro_cuenta: "",
                    sucursal: "",
                    cuit: "",
                    banco: "",
                    CBU: ""

                  }

                  this.getcbu();
                } else if (response.data.status == 1062) {
                  this.showNotification({
                    msj: "La empresa ya cuenta con el servicio adherido.",
                    bg: "bg-red"
                  });
                } else {
                  this.showNotification({
                    msj: "Error al configurar el DA.",
                    bg: "bg-red"
                  });
                }

                this.loading = false;
              });
          } else {
            this.showNotification({
              msj: "Faltan datos a completar",
              bg: "bg-red"
            });
          }
        } else {
          this.showNotification({
            msj: "DNI incorrecto.",
            bg: "bg-red"
          });
        }
      } else {
        this.showNotification({
          msj: "CBU incorrecto",
          bg: "bg-red"
        });
      }

    },
    getmods_set_cuit() {
      let cuit_empresa = this.razones_soc.filter(obj => {
        return obj.id === this.empresa
      });
      if (typeof cuit_empresa[0] !== 'undefined') {
        this.banco.cuit = cuit_empresa[0].cuit;
      } else {
        this.banco = {
          nombre: "",
          dni: "",
          tipo_cuenta: "CC",
          nro_cuenta: "",
          sucursal: "",
          cuit: "",
          banco: "",
          CBU: ""
        };
      }
      if (this.formapago == "1") {
        this.getcard();
      } else {
        this.getcbu();
      }
    },
    getcbu() {
      this.loading = true;
      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "getcbu",
            rz: this.empresa
          },
          {
            withCredentials: true
          }
        )
        .then(response => {

          if (response.data.status == 1) {
            this.pago = {
              tipo: response.data.data.tipo,
              numero: response.data.data.numero,
              cargada: response.data.data.cargada
            }
            this.card.email = response.data.data.mail;
          } else {
            this.pago = {
              tipo: "",
              numero: "",
              cargada: ""
            }
            this.card.email = "";
            this.getcard();
          }

          this.loading = false;
        });

    },
    chk_card_number(e) {


      let value = e.target.value;

      let v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')

      let matches = v.match(/\d{4,16}/g);
      let match = matches && matches[0] || ''
      let parts = []

      for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
      }

      if (parts.length) {
        this.card.numero = parts.join(' ');
      } else {
        this.card.numero = v;
      }

    },
    chk_dni(e) {

      let value = e.target.value;
      let v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')

      this.banco.dni = v.substring(0, 8);
      this.card.dni = v.substring(0, 8);

    },
    chk_cuit(e) {

      let value = e.target.value;
      let v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')


      this.banco.cuit = v.substring(0, 11);

    },
    chk_cbu(e) {
      let value = e.target.value;
      let v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      this.banco.CBU = v.substring(0, 22);

    },
    chk_cvc(e) {
      let value = e.target.value;
      let v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      this.card.cvc = v.substring(0, 3);
    },
    get_razones_sociales() {
      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "razSc",
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status == 1) {
            this.razones_soc = response.data.data;
          }else{
            this.razones_soc=[];
          }
          this.loading = false;
        });
    },
    getcard() {

      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "getcard",
            rz: this.empresa
          },
          {
            withCredentials: true
          }
        )
        .then(response => {

          if (response.data.status == 1) {

            this.pago = {
              tipo: response.data.data.tipo,
              numero: response.data.data.numero,
              cargada: response.data.data.cargada
            }

            this.card.email = response.data.data.mail;
          } else {

            this.pago = {
              tipo: "",
              numero: "",
              cargada: ""
            }

            this.card.email = "";

             


          }



          this.loading = false;
        });

    },
    delle() {
      if (this.formapago == "1") {
        this.dellCard();
      } else {
        this.dellCbu();
      }
    },
    dellCard() {
      if (confirm("Desea frenar el débito automático?")) {
        this.$http
          .post(
            "SERVER/scd/configs/",
            {
              a: "dellcard",
              rz: this.empresa
            },
            {
              withCredentials: true
            }
          )
          .then(response => {

            if (response.data.status == 1) {

              this.showNotification({
                msj: "Tarjeta eliminada",
                bg: "bg-green"
              });

              this.getcard();
            } else {
              this.showNotification({
                msj: "Error al eliminar la tarjeta, contacte con Fidelius.",
                bg: "bg-red"
              });
            }

            this.loading = false;
          });
      }



    },
    dellCbu() {
      if (confirm("Desea frenar el débito automático?")) {
        this.$http
          .post(
            "SERVER/scd/configs/",
            {
              a: "dellcbu",
              rz: this.empresa
            },
            {
              withCredentials: true
            }
          )
          .then(response => {

            if (response.data.status == 1) {

              this.showNotification({
                msj: "CBU eliminado",
                bg: "bg-green"
              });

              this.getcard();
            } else {
              this.showNotification({
                msj: "Error al eliminar CBU, contacte con Fidelius.",
                bg: "bg-red"
              });
            }

            this.loading = false;
          });
      }



    },
    upload_card() {


      if (this.card.dni.length > 6 && this.card.dni.length < 9) {

        if (this.card.nombre != "" &&
          this.card.tipo != "" &&
          this.card.tipo != "0" &&
          this.card.numero != "" &&
          this.card.dni != "" &&
          this.card.mes != "" &&
          this.card.anno != "" &&
          this.empresa != 0 &&
          this.card.email != "" &&

          this.card.cvc != "") {
          this.loading = true;
          this.$http
            .post(
              "SERVER/scd/configs/",
              {
                a: "upcard",
                data: this.card,
                rz: this.empresa
              },
              {
                withCredentials: true
              }
            )
            .then(response => {
              if (response.data.status == 1) {
                this.showNotification({
                  msj: "Tarjeta asociada",
                  bg: "bg-green"
                });

                this.card = {
                  tipo: "0",
                  numero: "",
                  dni: "",
                  mes: "",
                  anno: "",
                  cvc: "",
                  nombre: "",
                  email: ""

                }
                this.getcard();
              } else if (response.data.status == 1062) {
                this.showNotification({
                  msj: "La empresa ya cuenta con el servicio adherido.",
                  bg: "bg-red"
                });
              } else {
                this.showNotification({
                  msj: "Error al configurar la tarjeta.",
                  bg: "bg-red"
                });
              }

              this.loading = false;
            });
        } else {
          this.showNotification({
            msj: "Faltan datos a completar",
            bg: "bg-red"
          });
        }
      } else {
        this.showNotification({
          msj: "DNI incorrecto.",
          bg: "bg-red"
        });
      }

    }

  }
};



// WEBPACK FOOTER //
// ./src/components/configs/debAuto/main/index.js